class QCVGenerator {
  constructor(cc) {
    this.resizeCanvasToDisplaySize(cc);
    this.ctx = cc.getContext('2d');
  }

  resizeCanvasToDisplaySize(canvas) {
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;

    if (canvas.width !== width || canvas.height !== height) {
      canvas.width = width;
      canvas.height = height;
      return true;
    }

    return false;
  }

  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }

  generateQCV(colors) {
    let sum = 0;
    for (let i = 0; i < colors.length; i++) {
      sum += colors[i].amount;
    }
    if (sum !== 100) return;

    if (colors.length > 0) {
      let myColors = [];
      let i,
        j = 0;

      for (i = 0; i < colors.length; i++) {
        for (j = 0; j < colors[i].amount; j++) {
          myColors.push({ color: this.hexToRgb(colors[i].color.hex) });
        }
      }

      const w = this.ctx.canvas.width;
      const h = this.ctx.canvas.height;
      let imageData = this.ctx.getImageData(0, 0, w, h);
      let data = imageData.data;
      let colIndex = 0;
      for (i = 0; i < data.length; i = i + 4) {
        colIndex = Math.floor((Math.random() * 100) | 0);

        let val = myColors[colIndex].color;

        let r = val.r;
        let g = val.g;
        let b = val.b;
        data[i] = r;
        data[i + 1] = g;
        data[i + 2] = b;
        data[i + 3] = 255;
      }
      this.ctx.putImageData(imageData, 0, 0);
      this.ctx.canvas.style.webkitFilter = 'blur(.35px)';
    }
  }
}

export default QCVGenerator;
